import { render, staticRenderFns } from "./secretaria.vue?vue&type=template&id=4ac0645d&scoped=true"
import script from "./secretaria.vue?vue&type=script&lang=js"
export * from "./secretaria.vue?vue&type=script&lang=js"
import style0 from "./secretaria.vue?vue&type=style&index=0&id=4ac0645d&prod&lang=scss"
import style1 from "./secretaria.vue?vue&type=style&index=1&id=4ac0645d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac0645d",
  null
  
)

export default component.exports